import { Editable } from "../../../../base/components/advanced/input/editable"
import { A } from "../../../../base/components/native/a"
import { Img } from "../../../../base/components/native/img"
import { moveCursorToEnd, selectAllContent } from "../../../../base/helpers/components"
import { IMAGES } from "../../../../configs/images"
import { editableStyle, externalLinkStyle, linkTdStyle } from "./link-td.style"
import { RateTd } from "./rate-td"

export const LinkTd = (v?: string) => {

    let changed = false

    const base = RateTd()

    let decoded = ''
    try {
        decoded = decodeURIComponent(v || '-')
    } catch (error) {
        console.error('Error decoding link:', error, v);
    }
    const e = Editable({
        text: decoded
    })
    e.cssClass(editableStyle)
    e.el.setAttribute('dir', 'ltr')
    e.on('input', () => {
        moveCursorToEnd(e.el);
    })
    // select all text on focus
    e.on('focus', () => {
        selectAllContent(e.el);
    })
    e.on('enter', () => {
        e.blur()
    })
    e.on('paste', (c: ClipboardEvent) => {
        if (c.clipboardData) {
            const decoded = decodeURIComponent(c.clipboardData.getData('text/plain'))
            c.preventDefault()
            e.setValue(decoded)
        }
    })
    e.on('blur', () => {
        if (e.getValue() !== decoded) {
            changed = true
        } else {
            changed = false
        }
        if (e.getValue().includes('http')) {
            externalLinkIcon.style({ display: 'block' })
        } else {
            externalLinkIcon.style({ display: 'none' })
        }
        base.emit('change', e.getValue())
    })

    base.append(e)
    base.cssClass(linkTdStyle)

    const externalLinkIcon = Img(IMAGES.ICONS.LINK, { width: 20 })
    externalLinkIcon.cssClass(externalLinkStyle)
    base.append(externalLinkIcon)
    if (v) externalLinkIcon.style({ display: 'block' })
    externalLinkIcon.el.onclick = () => {
        window.open(e.getValue(), '_blank')
    }

    // if (v) {
    //     const externalLink = A(v, '', '_blank')
    //     const externalLinkIcon = Img(IMAGES.ICONS.LINK, { width: 20 })
    //     externalLink.cssClass(externalLinkStyle)
    //     externalLink.append(externalLinkIcon)
    //     base.append(externalLink)
    // }

    return Object.assign(base, {
        getValue: () => {
            return e.getValue().replace(/ /g, '').replace('<br>', '')
        },
        changed: () => changed
    })
}

